class SubcollectionPills extends HTMLElement {
  connectedCallback() {
    const listEl = this.querySelector("[data-list]");
    const leftBtn = this.querySelector("[data-left]");
    const rightBtn = this.querySelector("[data-right]");
    const gradLeft = this.querySelector("[data-grad-left]");
    const gradRight = this.querySelector("[data-grad-right]");

    if (!listEl || !leftBtn || !rightBtn || !gradLeft || !gradRight) return;

    const step = 200;
    const threshold = 20;

    const show = (el) => {
      el.classList.remove("hidden");
      el.classList.add("inline-flex");
    };
    const hide = (el) => {
      el.classList.add("hidden");
      el.classList.remove("inline-flex");
    };
    const update = () => {
      const maxScrollLeft = Math.max(0, listEl.scrollWidth - listEl.clientWidth);
      const left = listEl.scrollLeft;
      const showLeft = left > threshold;
      const showRight = left < maxScrollLeft - threshold;

      showLeft ? (show(leftBtn), gradLeft.removeAttribute("hidden")) : (hide(leftBtn), gradLeft.setAttribute("hidden", ""));
      showRight ? (show(rightBtn), gradRight.removeAttribute("hidden")) : (hide(rightBtn), gradRight.setAttribute("hidden", ""));
    };

    leftBtn.addEventListener("click", () => listEl.scrollBy({ left: -step, behavior: "smooth" }));
    rightBtn.addEventListener("click", () => listEl.scrollBy({ left: step, behavior: "smooth" }));
    listEl.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    listEl.scrollLeft = 0;
    requestAnimationFrame(() => requestAnimationFrame(update));
  }
}

customElements.define("subcollection-pills", SubcollectionPills);

(function () {
  "use strict";

  let currentAbortController = null;
  let mobileFiltersCleared = false;
  let priceCountAbortController = null;

  function getContentEl() {
    return document.getElementById("collection-content");
  }

  function getSectionId() {
    const el = getContentEl();
    return el ? el.dataset.sectionId : null;
  }

  function getNonPriceParams() {
    const params = new URLSearchParams(window.location.search);
    params.delete("filter.v.price.gte");
    params.delete("filter.v.price.lte");
    return params;
  }

  async function fetchPriceRangeCounts() {
    if (priceCountAbortController) priceCountAbortController.abort();
    priceCountAbortController = new AbortController();
    const signal = priceCountAbortController.signal;

    const buttons = document.querySelectorAll("[data-desktop-filters] [data-price-filter], [data-mobile-filter-body] [data-price-filter]");
    if (!buttons.length) return;

    const baseParams = getNonPriceParams();
    const basePath = window.location.pathname;

    const fetches = Array.from(buttons).map(async (btn) => {
      const gte = btn.dataset.gte;
      const lte = btn.dataset.lte;
      const rangeParams = new URLSearchParams(baseParams);
      if (gte && gte !== "0") rangeParams.set("filter.v.price.gte", gte);
      if (lte && lte !== "999999") rangeParams.set("filter.v.price.lte", lte);
      rangeParams.set("section_id", "collection-count");

      const url = `${basePath}?${rangeParams.toString()}`;

      try {
        const res = await fetch(url, { signal });
        if (!res.ok) return { btn, count: -1 };
        const html = await res.text();
        const match = html.match(/data-count="(\d+)"/);
        const count = match ? parseInt(match[1], 10) : -1;
        return { btn, count };
      } catch (e) {
        if (e.name === "AbortError") return null;
        return { btn, count: -1 };
      }
    });

    const results = await Promise.all(fetches);

    for (const result of results) {
      if (!result) continue;
      const { btn, count } = result;
      const countEl = btn.querySelector("[data-price-count]");

      if (count === 0) {
        btn.style.display = "none";
      } else {
        btn.style.display = "";
        if (countEl && count > 0) {
          countEl.textContent = count;
        }
      }
    }
  }

  function syncPriceFilterStates() {
    const params = new URLSearchParams(window.location.search);
    const priceRangesStr = params.get("price_ranges");
    const activeRanges = priceRangesStr ? priceRangesStr.split(",") : [];

    document.querySelectorAll("[data-price-filter]").forEach((btn) => {
      const key = `${btn.dataset.gte}-${btn.dataset.lte}`;
      const box = btn.querySelector("span:first-child");
      if (!box) return;

      const isActive = activeRanges.includes(key);
      const isDesktop = !!btn.closest("[data-desktop-filters]");

      if (isActive) {
        box.classList.add("bg-black");
        if (!isDesktop) {
          box.classList.add("border-black");
          box.classList.remove("border-zinc-400");
        }
      } else {
        box.classList.remove("bg-black");
        if (!isDesktop) {
          box.classList.remove("border-black");
          box.classList.add("border-zinc-400");
        }
      }
    });
  }

  function scrollToFilters() {
    const content = getContentEl();
    if (!content) return;

    const anchor = document.getElementById("productGridInfoContainer");
    const stickyTop = anchor
      ? parseFloat(window.getComputedStyle(anchor).top)
      : 0;
    const offset = Number.isFinite(stickyTop) ? stickyTop : 0;
    const target = Math.max(
      0,
      window.scrollY + content.getBoundingClientRect().top - offset
    );

    if (Math.abs(window.scrollY - target) < 2) return;

    window.scrollTo({ top: target, behavior: "auto" });
  }

  function showLoading() {
    const grid = document.getElementById("product-grid");
    const loadMore = document.getElementById("load-more-container");
    const loader = document.getElementById("collection-loading");
    const content = getContentEl();
    if (content) content.style.minHeight = `${content.offsetHeight}px`;
    if (grid) grid.classList.add("hidden");
    if (loadMore) loadMore.classList.add("hidden");
    if (loader) loader.classList.remove("hidden");
  }

  function hideLoading() {
    const grid = document.getElementById("product-grid");
    const loadMore = document.getElementById("load-more-container");
    const loader = document.getElementById("collection-loading");
    const content = getContentEl();
    if (content) content.style.minHeight = "";
    if (grid) grid.classList.remove("hidden");
    if (loadMore) loadMore.classList.remove("hidden");
    if (loader) loader.classList.add("hidden");
  }

  async function fetchSection(url, signal) {
    const sectionId = getSectionId();
    if (!sectionId) return null;

    const separator = url.includes("?") ? "&" : "?";
    const fetchUrl = `${url}${separator}section_id=${sectionId}`;

    const res = await fetch(fetchUrl, { signal });
    if (!res.ok) throw new Error(`Section fetch failed: ${res.status}`);

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.getElementById("collection-content");
  }

  async function fetchAndReplace(url, pushState = true, beforeFilterChips) {
    if (currentAbortController) currentAbortController.abort();
    currentAbortController = new AbortController();

    if (pushState) scrollToFilters();

    showLoading();

    const sentinel = document.getElementById("load-more-sentinel");
    if (sentinel) sentinel.classList.add("hidden");

    try {
      const newContent = await fetchSection(url, currentAbortController.signal);
      if (!newContent) return;

      const oldContent = getContentEl();
      if (oldContent) {
        oldContent.replaceWith(newContent);
      }

      if (pushState) {
        const cleanUrl = url.split("?")[0] + "?" + url.split("?").slice(1).join("?");
        window.history.pushState({}, "", cleanUrl);
      }

      bindEventListeners();
      syncPriceFilterStates();
      syncFilterChips();
      fetchPriceRangeCounts();
      // Leaf - Custom Event - apply_filter, remove_filter - Start
      //
      // beforeFilterChips is only passed by the filter-mutating call sites
      // (checkbox/toggle/price clicks, pill removal, clear all, mobile
      // "Apply Filters") - not by handleSortChange, loadNextPage (uses
      // fetchSection directly, not this function), or the popstate listener
      // - so sort changes, infinite scroll, and browser back/forward never
      // fire apply_filter/remove_filter, only genuine filter actions do.
      if (beforeFilterChips && window.LeafCustomEvents) {
        publishFilterDiff(beforeFilterChips, getActiveFilterChips(newContent), getResultsCount(newContent));
      }
      // Leaf - Custom Event - apply_filter, remove_filter - End
    } catch (e) {
      if (e.name === "AbortError") return;
      console.error("Collection fetch error:", e);
    } finally {
      hideLoading();
      currentAbortController = null;
    }
  }

  function appendUnrenderedFilters(params, container) {
    const rendered = new Set();

    container.querySelectorAll("[data-filter-checkbox]").forEach((input) => {
      rendered.add(input.name + "\n" + input.value);
    });

    container.querySelectorAll("[data-filter-toggle]").forEach((btn) => {
      rendered.add(btn.dataset.param + "\n" + btn.dataset.value);
    });

    new URLSearchParams(window.location.search).forEach((value, name) => {
      if (name.indexOf("filter.") !== 0) return;
      if (name.indexOf("filter.v.price") === 0) return;
      if (rendered.has(name + "\n" + value)) return;
      if (params.getAll(name).indexOf(value) !== -1) return;
      params.append(name, value);
    });
  }

  const FILTER_LABEL_STORE = "tb:filter-labels";

  function loadFilterLabels() {
    try {
      return JSON.parse(sessionStorage.getItem(FILTER_LABEL_STORE) || "{}");
    } catch (e) {
      return {};
    }
  }

  function saveFilterLabels(map) {
    try {
      sessionStorage.setItem(FILTER_LABEL_STORE, JSON.stringify(map));
    } catch (e) {}
  }

  function groupLabelFor(input) {
    const dropdown = input.closest("[data-filter-dropdown]");
    if (dropdown) {
      const trigger = dropdown.querySelector("[data-filter-trigger] span");
      if (trigger) return trigger.textContent.trim();
    }
    const details = input.closest("details");
    if (details) {
      const summary = details.querySelector("summary span");
      if (summary) {
        const first = summary.childNodes[0];
        if (first && first.textContent && first.textContent.trim()) {
          return first.textContent.trim();
        }
        return summary.textContent.trim();
      }
    }
    return "";
  }

  function captureFilterLabels() {
    const map = loadFilterLabels();
    let changed = false;

    document.querySelectorAll("[data-filter-checkbox]").forEach((input) => {
      const label = input.closest("label");
      if (!label) return;
      const spans = label.querySelectorAll("span");
      const valueLabel = spans[1] ? spans[1].textContent.trim() : "";
      if (!valueLabel) return;
      const groupLabel = groupLabelFor(input);
      const key = input.name + "\n" + input.value;
      const existing = map[key];
      const mergedGroup = groupLabel || (existing && existing.g) || "";
      if (!existing || existing.v !== valueLabel || existing.g !== mergedGroup) {
        map[key] = { g: mergedGroup, v: valueLabel };
        changed = true;
      }
    });

    if (changed) saveFilterLabels(map);
  }

  function buildRemoveUrl(name, value) {
    const params = new URLSearchParams(window.location.search);
    const kept = params.getAll(name).filter((v) => v !== value);
    params.delete(name);
    kept.forEach((v) => params.append(name, v));
    const query = params.toString();
    return window.location.pathname + (query ? "?" + query : "");
  }

  function restoreHiddenFilterChips() {
    const anyChip = document.querySelector("[data-filter-remove][data-filter-param]");
    if (!anyChip || !anyChip.parentElement) return;
    const row = anyChip.parentElement;

    const rendered = new Set();
    row.querySelectorAll("[data-filter-remove][data-filter-param]").forEach((chip) => {
      rendered.add(chip.dataset.filterParam + "\n" + chip.dataset.filterValue);
    });

    const labels = loadFilterLabels();

    new URLSearchParams(window.location.search).forEach((value, name) => {
      if (name.indexOf("filter.") !== 0) return;
      if (name.indexOf("filter.v.price") === 0) return;

      const key = name + "\n" + value;
      if (rendered.has(key)) return;

      const known = labels[key];
      if (!known || !known.v) return;

      rendered.add(key);

      const chip = document.createElement("a");
      chip.href = buildRemoveUrl(name, value);
      chip.className = anyChip.className;
      chip.setAttribute("data-filter-remove", "");
      chip.setAttribute("data-filter-param", name);
      chip.setAttribute("data-filter-value", value);
      chip.innerHTML =
        '<span></span><svg class="w-3 h-3 shrink-0" viewBox="0 0 12 12" fill="none"><path d="M1 1L11 11" stroke="black" stroke-linecap="round"/><path d="M1 11L11 1" stroke="black" stroke-linecap="round"/></svg>';
      chip.querySelector("span").textContent = known.g
        ? known.g + ": " + known.v
        : known.v;

      const clearAll = row.querySelector("[data-filter-clear-all]");
      if (clearAll) {
        row.insertBefore(chip, clearAll);
      } else {
        row.appendChild(chip);
      }
    });
  }

  function syncFilterChips() {
    captureFilterLabels();
    restoreHiddenFilterChips();
  }

  function buildFilterUrl() {
    const params = new URLSearchParams();
    const desktopBar = document.querySelector("[data-desktop-filters]");
    if (!desktopBar) return window.location.pathname;

    desktopBar.querySelectorAll("[data-filter-checkbox]:checked").forEach((input) => {
      params.append(input.name, input.value);
    });

    desktopBar.querySelectorAll("[data-filter-toggle].bg-black").forEach((btn) => {
      params.append(btn.dataset.param, btn.dataset.value);
    });

    const priceRanges = [];
    desktopBar.querySelectorAll("[data-price-filter]").forEach((btn) => {
      const box = btn.querySelector("span:first-child");
      if (box && box.classList.contains("bg-black")) {
        priceRanges.push({ gte: parseInt(btn.dataset.gte, 10), lte: parseInt(btn.dataset.lte, 10) });
      }
    });
    if (priceRanges.length > 0) {
      const mergedGte = Math.min(...priceRanges.map((r) => r.gte));
      const mergedLte = Math.max(...priceRanges.map((r) => r.lte));
      if (mergedGte > 0) params.set("filter.v.price.gte", mergedGte);
      if (mergedLte < 999999) params.set("filter.v.price.lte", mergedLte);
      params.set("price_ranges", priceRanges.map((r) => `${r.gte}-${r.lte}`).join(","));
    }

    appendUnrenderedFilters(params, desktopBar);

    const sortSelect = desktopBar.querySelector("[data-sort-select]");
    if (sortSelect && sortSelect.value) {
      params.set("sort_by", sortSelect.value);
    }

    return `${window.location.pathname}?${params.toString()}`;
  }

  function buildMobileFilterUrl() {
    const params = new URLSearchParams();
    const drawer = document.getElementById("mobile-filter-drawer");
    if (!drawer) return window.location.pathname;

    drawer.querySelectorAll("[data-filter-checkbox]:checked").forEach((input) => {
      params.append(input.name, input.value);
    });

    drawer.querySelectorAll("[data-filter-toggle].bg-black").forEach((btn) => {
      params.append(btn.dataset.param, btn.dataset.value);
    });

    const mobileBody = drawer.querySelector("[data-mobile-filter-body]");
    if (mobileBody) {
      const mPriceRanges = [];
      mobileBody.querySelectorAll("[data-price-filter]").forEach((btn) => {
        const box = btn.querySelector("span:first-child");
        if (box && box.classList.contains("bg-black")) {
          mPriceRanges.push({ gte: parseInt(btn.dataset.gte, 10), lte: parseInt(btn.dataset.lte, 10) });
        }
      });
      if (mPriceRanges.length > 0) {
        const mMergedGte = Math.min(...mPriceRanges.map((r) => r.gte));
        const mMergedLte = Math.max(...mPriceRanges.map((r) => r.lte));
        if (mMergedGte > 0) params.set("filter.v.price.gte", mMergedGte);
        if (mMergedLte < 999999) params.set("filter.v.price.lte", mMergedLte);
        params.set("price_ranges", mPriceRanges.map((r) => `${r.gte}-${r.lte}`).join(","));
      }
    }

    if (!mobileFiltersCleared) {
      appendUnrenderedFilters(params, drawer);
    }

    const sortSelect = document.querySelector("[data-sort-select]");
    if (sortSelect && sortSelect.value) {
      params.set("sort_by", sortSelect.value);
    }

    return `${window.location.pathname}?${params.toString()}`;
  }

  function handleDesktopFilterChange() {
    closeAllDropdowns();
    const url = buildFilterUrl();
    // Leaf - Custom Event - apply_filter, remove_filter - Start
    fetchAndReplace(url, true, getActiveFilterChips());
    // Leaf - Custom Event - apply_filter, remove_filter - End
  }

  function handleDesktopToggle(btn) {
    const isActive = btn.classList.contains("bg-black");
    if (isActive) {
      btn.classList.remove("bg-black", "text-white");
      btn.classList.add("bg-white", "text-black");
    } else {
      btn.classList.add("bg-black", "text-white");
      btn.classList.remove("bg-white", "text-black");
    }
    handleDesktopFilterChange();
  }

  function handleDesktopPriceFilter(btn) {
    const box = btn.querySelector("span:first-child");
    if (!box) return;

    if (box.classList.contains("bg-black")) {
      box.classList.remove("bg-black");
    } else {
      box.classList.add("bg-black");
    }

    handleDesktopFilterChange();
  }

  let openPanelScrollY = null;

  function positionDropdownPanel(dropdown) {
    const panel = dropdown.querySelector("[data-filter-panel]");
    const trigger = dropdown.querySelector("[data-filter-trigger]");
    if (!panel || !trigger) return;

    const rect = trigger.getBoundingClientRect();
    const panelWidth = 245;
    let left = rect.left;
    if (left + panelWidth > window.innerWidth - 16) {
      left = window.innerWidth - panelWidth - 16;
    }

    panel.style.position = "fixed";
    panel.style.top = rect.bottom + 8 + "px";
    panel.style.left = left + "px";
    panel.style.zIndex = "9999";
  }

  function openDropdown(dropdown) {
    const panel = dropdown.querySelector("[data-filter-panel]");
    const trigger = dropdown.querySelector("[data-filter-trigger]");
    if (!panel || !trigger) return;

    closeAllDropdowns();
    closeSortPanel();

    positionDropdownPanel(dropdown);
    openPanelScrollY = window.scrollY;

    panel.classList.remove("hidden");
    trigger.setAttribute("aria-expanded", "true");
  }

  function closeDropdown(dropdown) {
    const panel = dropdown.querySelector("[data-filter-panel]");
    const trigger = dropdown.querySelector("[data-filter-trigger]");
    if (panel) {
      panel.classList.add("hidden");
      panel.style.position = "";
      panel.style.top = "";
      panel.style.left = "";
      panel.style.zIndex = "";
    }
    if (trigger) trigger.setAttribute("aria-expanded", "false");
  }

  function closeAllDropdowns() {
    document.querySelectorAll("[data-filter-dropdown]").forEach(closeDropdown);
  }

  function closeSortPanel() {
    document.querySelectorAll("[data-sort-panel]").forEach((panel) => {
      panel.classList.add("hidden");
    });
    document.querySelectorAll("[data-sort-trigger]").forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
  }

  function initFilterScroll() {
    const scroller = document.querySelector("[data-filter-scroller]");
    const leftBtn = document.querySelector("[data-filter-scroll-left]");
    const rightBtn = document.querySelector("[data-filter-scroll-right]");
    const gradLeft = document.querySelector("[data-filter-grad-left]");
    const gradRight = document.querySelector("[data-filter-grad-right]");

    if (!scroller || !leftBtn || !rightBtn || !gradLeft || !gradRight) return;

    const step = 200;
    const threshold = 20;

    const show = (el) => { el.classList.remove("hidden"); el.classList.add("inline-flex"); };
    const hide = (el) => { el.classList.add("hidden"); el.classList.remove("inline-flex"); };

    const showGrad = (el) => { el.style.setProperty("display", "block", "important"); };
    const hideGrad = (el) => { el.style.setProperty("display", "none", "important"); };

    const update = () => {
      const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const left = scroller.scrollLeft;

      left > threshold ? (show(leftBtn), showGrad(gradLeft)) : (hide(leftBtn), hideGrad(gradLeft));
      left < maxScroll - threshold ? (show(rightBtn), showGrad(gradRight)) : (hide(rightBtn), hideGrad(gradRight));
    };

    leftBtn.addEventListener("click", () => scroller.scrollBy({ left: -step, behavior: "smooth" }));
    rightBtn.addEventListener("click", () => scroller.scrollBy({ left: step, behavior: "smooth" }));
    scroller.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    scroller.scrollLeft = 0;
    requestAnimationFrame(() => requestAnimationFrame(update));
  }

  const checkSvg = '<svg class="w-3 h-3 text-white" viewBox="0 0 10 10" fill="none"><path d="M1.5 5L4 7.5L8.5 2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function showFilterDetail(index) {
    const drawer = document.getElementById("mobile-filter-drawer");
    if (!drawer) return;
    const mainView = drawer.querySelector("[data-filter-main-view]");
    if (mainView) mainView.classList.add("hidden");
    drawer.querySelectorAll("[data-filter-detail]").forEach((el) => el.classList.add("hidden"));
    const detail = drawer.querySelector('[data-filter-detail="' + index + '"]');
    if (detail) detail.classList.remove("hidden");
    const backBtn = drawer.querySelector("[data-mobile-back]");
    if (backBtn) backBtn.classList.remove("invisible");
    const title = drawer.querySelector("[data-mobile-title]");
    const categoryBtn = drawer.querySelector('[data-mobile-category="' + index + '"]');
    if (title && categoryBtn) title.textContent = categoryBtn.dataset.filterLabel;
  }

  function showFilterMain() {
    const drawer = document.getElementById("mobile-filter-drawer");
    if (!drawer) return;
    drawer.querySelectorAll("[data-filter-detail]").forEach((el) => el.classList.add("hidden"));
    const mainView = drawer.querySelector("[data-filter-main-view]");
    if (mainView) mainView.classList.remove("hidden");
    const backBtn = drawer.querySelector("[data-mobile-back]");
    if (backBtn) backBtn.classList.add("invisible");
    const title = drawer.querySelector("[data-mobile-title]");
    if (title) title.textContent = "Filters";
  }

  function setChatWidgetVisibility(visible) {
    var chat = document.getElementById("chat-widget-container");
    if (!chat) return;
    chat.style.transition = "opacity .3s ease, visibility .3s ease";
    if (visible) {
      chat.style.opacity = "1";
      chat.style.visibility = "visible";
    } else {
      chat.style.opacity = "0";
      chat.style.visibility = "hidden";
    }
  }

  function openMobileDrawer() {
    const drawer = document.getElementById("mobile-filter-drawer");
    if (!drawer) return;
    mobileFiltersCleared = false;
    drawer.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    setChatWidgetVisibility(false);
    showFilterMain();
  }

  function closeMobileDrawer() {
    const drawer = document.getElementById("mobile-filter-drawer");
    if (!drawer) return;
    drawer.classList.add("hidden");
    document.body.style.overflow = "";
    setChatWidgetVisibility(true);
  }

  function applyMobileFilters() {
    // Leaf - Custom Event - apply_filter, remove_filter - Start
    // Captured before closeMobileDrawer()/fetchAndReplace() run - the drawer's
    // checkbox/price toggles only update in-drawer visual state and the
    // "Apply Filters (N products)" live-preview count, they never touch the
    // "Selected Filters" pill row this reads, so this always reflects the
    // filter state that was actually applied before the drawer was opened,
    // regardless of how many toggles happened inside it.
    const beforeFilterChips = getActiveFilterChips();
    // Leaf - Custom Event - apply_filter, remove_filter - End
    closeMobileDrawer();
    const url = buildMobileFilterUrl();
    mobileFiltersCleared = false;
    // Leaf - Custom Event - apply_filter, remove_filter - Start
    fetchAndReplace(url, true, beforeFilterChips);
    // Leaf - Custom Event - apply_filter, remove_filter - End
  }

  function clearMobileFilters() {
    const drawer = document.getElementById("mobile-filter-drawer");
    if (!drawer) return;

    mobileFiltersCleared = true;

    drawer.querySelectorAll("[data-filter-checkbox]").forEach((cb) => {
      cb.checked = false;
      const box = cb.closest("label")?.querySelector("span:first-child");
      if (box) {
        box.classList.remove("border-black", "bg-black");
        box.classList.add("border-zinc-400");
        box.innerHTML = "";
      }
    });

    drawer.querySelectorAll("[data-price-filter]").forEach((btn) => {
      const box = btn.querySelector("span:first-child");
      if (box) {
        box.classList.remove("border-black", "bg-black");
        box.classList.add("border-zinc-400");
        box.innerHTML = "";
      }
    });

    showFilterMain();
    updateMobileApplyCount();
  }

  let applyCountTimer = null;
  let applyCountController = null;

  function updateMobileApplyCount() {
    clearTimeout(applyCountTimer);
    const btn = document.querySelector("[data-mobile-filter-apply]");
    if (btn) btn.textContent = "Applying Filters\u2026";

    applyCountTimer = setTimeout(async () => {
      if (applyCountController) applyCountController.abort();
      applyCountController = new AbortController();

      try {
        const url = buildMobileFilterUrl();
        const newContent = await fetchSection(url, applyCountController.signal);
        if (!newContent) return;

        const countEl = newContent.querySelector("#products-count-mobile");
        if (countEl) {
          const match = countEl.textContent.match(/(\d+)/);
          if (match && btn) {
            btn.innerHTML = `APPLY FILTERS (<span data-mobile-apply-count>${match[1]}</span>&nbsp;PRODUCTS)`;
          }
        }
      } catch (e) {
        if (e.name === "AbortError") return;
      }
    }, 300);
  }

  function handleMobileCheckboxToggle(label) {
    const cb = label.querySelector("[data-filter-checkbox]");
    if (!cb) return;
    const box = label.querySelector("span:first-child");
    if (!box) return;
    if (cb.checked) {
      box.classList.add("border-black", "bg-black");
      box.classList.remove("border-zinc-400");
      box.innerHTML = checkSvg;
    } else {
      box.classList.remove("border-black", "bg-black");
      box.classList.add("border-zinc-400");
      box.innerHTML = "";
    }
    updateMobileApplyCount();
  }

  function handleMobilePriceToggle(btn) {
    const box = btn.querySelector("span:first-child");
    if (!box) return;

    if (box.classList.contains("bg-black")) {
      box.classList.remove("border-black", "bg-black");
      box.classList.add("border-zinc-400");
    } else {
      box.classList.add("border-black", "bg-black");
      box.classList.remove("border-zinc-400");
    }
    updateMobileApplyCount();
  }

  let isLoadingMore = false;
  let scrollObserver = null;

  // Leaf - Custom Event - collection_scroll - Start
  //
  // Tracks which infinite-scroll batch is being loaded for the current
  // collection view. Reset to 0 here (not just once at page load) because
  // initInfiniteScroll() re-runs after every fetchAndReplace() - a filter,
  // sort, or pagination-resetting change always renders a fresh single-page
  // grid with its own new sentinel, so batch counting has to start over for
  // that new view rather than keep climbing from the previous one.
  let collectionScrollBatchIndex = 0;
  // Leaf - Custom Event - collection_scroll - End

  function initInfiniteScroll() {
    const sentinel = document.getElementById("load-more-sentinel");
    if (!sentinel) return;

        // Leaf - Custom Event - collection_scroll - Start
    collectionScrollBatchIndex = 0;
    // Leaf - Custom Event - collection_scroll - End

    if (scrollObserver) scrollObserver.disconnect();

    scrollObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !isLoadingMore) {
          loadNextPage(entry.target);
        }
      },
      { rootMargin: "0px 0px 400px 0px" }
    );

    scrollObserver.observe(sentinel);
  }

  async function loadNextPage(sentinel) {
    const nextUrl = sentinel.dataset.nextUrl;
    if (!nextUrl || isLoadingMore) return;

    isLoadingMore = true;

    try {
      const newContent = await fetchSection(nextUrl);
      if (!newContent) return;

      const newGrid = newContent.querySelector("#product-grid");
      const currentGrid = document.getElementById("product-grid");

      if (newGrid && currentGrid) {
        // Leaf - Custom Event - collection_scroll - Start
        // Captured before the while loop below empties newGrid by moving its
        // children one at a time - this is how many products this specific
        // batch contributed (e.g. 250 for a full batch, 75 for a final
        // partial one), not the collection-wide total.
        const batchItemCount = newGrid.children.length;
        // Leaf - Custom Event - collection_scroll - End
        while (newGrid.firstChild) {
          currentGrid.appendChild(newGrid.firstChild);
        }
        // Leaf - Custom Event - collection_scroll - Start
        if (window.LeafCustomEvents) {
          collectionScrollBatchIndex += 1;
          const contentEl = getContentEl();
          window.LeafCustomEvents.publish("collection_scroll", {
            collection_name: contentEl ? contentEl.dataset.gaCollectionName || "" : "",
            results_count: batchItemCount,
            batch_index: collectionScrollBatchIndex,
            items_loaded_total: currentGrid.children.length,
          });
        }
        // Leaf - Custom Event - collection_scroll - End
      }

      const newSentinel = newContent.querySelector("#load-more-sentinel");
      if (newSentinel) {
        sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
        scrollObserver.observe(sentinel);
      } else {
        sentinel.remove();
      }
    } catch (e) {
      if (e.name === "AbortError") return;
      console.error("Infinite scroll error:", e);
      sentinel.remove();
    } finally {
      isLoadingMore = false;
    }
  }

  // Leaf - Custom Event - apply_filter, remove_filter - Start
  //
  // Shared helpers used to detect which individual filter(s) actually
  // changed around a collection grid refresh, so apply_filter/remove_filter
  // can be broadcast per filter (not just "something changed"). The
  // "Selected Filters" pill row already rendered by the theme (see
  // sections/main-collection.liquid) is read directly rather than
  // re-deriving filter state from checkboxes/toggles, since that row
  // already reflects the true applied state (both before and after a
  // fetch), including for the mobile drawer's batched "Apply Filters"
  // click, where individual checkbox toggles inside the drawer don't touch
  // this pill row until Apply is clicked.
  function toSnakeCase(label) {
    return (label || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }

  function getActiveFilterChips(root) {
    var scope = root || document.getElementById("collection-content") || document;
    var chips = [];

    scope.querySelectorAll("[data-filter-remove]").forEach(function (el) {
      var textEl = el.querySelector("span") || el;
      var text = textEl.textContent.trim();
      var separatorIndex = text.indexOf(": ");
      if (separatorIndex === -1) return;
      chips.push({
        type: toSnakeCase(text.slice(0, separatorIndex)),
        value: text.slice(separatorIndex + 2).trim(),
      });
    });

    scope.querySelectorAll("[data-price-pill-remove]").forEach(function (btn) {
      var gte = btn.dataset.gte;
      var lte = btn.dataset.lte;
      if (gte === undefined || lte === undefined) return;
      chips.push({ type: "price", value: gte + "-" + lte });
    });

    return chips;
  }

  function getResultsCount(root) {
    var scope = root || document;
    var el = scope.querySelector("#products-count") || scope.querySelector("#products-count-mobile");
    if (!el) return undefined;
    var match = el.textContent.match(/[\d,]+/);
    return match ? parseInt(match[0].replace(/,/g, ""), 10) : undefined;
  }

  function formatActiveFilters(chips) {
    if (!chips.length) return "na";
    return chips.map(function (c) { return c.type + ":" + c.value; }).join("|");
  }

  // Diffs the pill row before/after a fetch and broadcasts one
  // apply_filter/remove_filter event per filter that appeared/disappeared -
  // one filter changing (the common case) fires one event; a "Clear all"
  // or a batched mobile "Apply Filters" covering several filters at once
  // fires one event per filter, all sharing the same resulting
  // active_filters/results_count since they all resolved from the same
  // fetch.
  function publishFilterDiff(beforeChips, afterChips, resultsCount) {
    function key(chip) {
      return chip.type + "::" + chip.value;
    }

    var beforeKeys = beforeChips.map(key);
    var afterKeys = afterChips.map(key);
    var activeFiltersStr = formatActiveFilters(afterChips);

    afterChips
      .filter(function (chip) { return beforeKeys.indexOf(key(chip)) === -1; })
      .forEach(function (chip) {
        window.LeafCustomEvents.publish("apply_filter", {
          filter_type: chip.type,
          filter_value: chip.value,
          active_filters: activeFiltersStr,
          results_count: resultsCount,
        });
      });

    beforeChips
      .filter(function (chip) { return afterKeys.indexOf(key(chip)) === -1; })
      .forEach(function (chip) {
        window.LeafCustomEvents.publish("remove_filter", {
          filter_type: chip.type,
          filter_value: chip.value,
          active_filters: activeFiltersStr,
          results_count: resultsCount,
        });
      });
  }
  // Leaf - Custom Event - apply_filter, remove_filter - End

// Leaf - Custom Event - apply_sort - Start
  var SORT_TYPE_MAP = {
    "": "relevance",
    "best-selling": "best_selling",
    "price-ascending": "price_low_to_high",
    "price-descending": "price_high_to_low",
  };
  // Leaf - Custom Event - apply_sort - End

  function handleSortChange() {
    // Leaf - Custom Event - apply_sort - Start
    if (window.LeafCustomEvents) {
      var sortSelect = document.querySelector("[data-sort-select]");
      var sortValue = sortSelect ? sortSelect.value : "";
      window.LeafCustomEvents.publish("apply_sort", {
        sort_type: SORT_TYPE_MAP.hasOwnProperty(sortValue) ? SORT_TYPE_MAP[sortValue] : sortValue,
      });
    }
    // Leaf - Custom Event - apply_sort - End

    const select = document.querySelector("[data-sort-select]");
    const value = select ? select.value : "";

    const params = new URLSearchParams(window.location.search);
    if (value) params.set("sort_by", value);
    else params.delete("sort_by");
    params.delete("page");

    const query = params.toString();
    fetchAndReplace(`${window.location.pathname}${query ? `?${query}` : ""}`);
  }

  function handleFilterRemove(e, link) {
    e.preventDefault();
    let url = link.getAttribute("href");
    if (!url) return;

    const currentParams = new URLSearchParams(window.location.search);
    const priceRanges = currentParams.get("price_ranges");
    if (priceRanges) {
      const removeUrl = new URL(url, window.location.origin);
      const removeKeepsPrice = removeUrl.searchParams.has("filter.v.price.gte") || removeUrl.searchParams.has("filter.v.price.lte");
      if (removeKeepsPrice) {
        removeUrl.searchParams.set("price_ranges", priceRanges);
        url = removeUrl.pathname + removeUrl.search;
      }
    }

    // Leaf - Custom Event - apply_filter, remove_filter - Start
    fetchAndReplace(url, true, getActiveFilterChips());
    // Leaf - Custom Event - apply_filter, remove_filter - End
  }

  function handleClearAll(e, link) {
    e.preventDefault();
    const url = link.getAttribute("href");
    // Leaf - Custom Event - apply_filter, remove_filter - Start
    if (url) fetchAndReplace(url, true, getActiveFilterChips());
    // Leaf - Custom Event - apply_filter, remove_filter - End
  }

  function handlePricePillRemove(btn) {
    const removeGte = btn.dataset.gte;
    const removeLte = btn.dataset.lte;
    const removeKey = `${removeGte}-${removeLte}`;

    const params = new URLSearchParams(window.location.search);
    const currentRanges = params.get("price_ranges");
    if (!currentRanges) return;

    const remaining = currentRanges.split(",").filter((r) => r !== removeKey);

    params.delete("price_ranges");
    params.delete("filter.v.price.gte");
    params.delete("filter.v.price.lte");

    if (remaining.length > 0) {
      params.set("price_ranges", remaining.join(","));
      const ranges = remaining.map((r) => {
        const [g, l] = r.split("-").map(Number);
        return { gte: g, lte: l };
      });
      const mergedGte = Math.min(...ranges.map((r) => r.gte));
      const mergedLte = Math.max(...ranges.map((r) => r.lte));
      if (mergedGte > 0) params.set("filter.v.price.gte", mergedGte);
      if (mergedLte < 999999) params.set("filter.v.price.lte", mergedLte);
    }

    const url = `${window.location.pathname}?${params.toString()}`;
    fetchAndReplace(url);
  }

  window.addEventListener("popstate", () => {
    fetchAndReplace(window.location.href, false);
  });

  function bindEventListeners() {
    const contentEl = getContentEl();
    if (!contentEl) return;

    if (!bindEventListeners._delegated) {
      bindEventListeners._delegated = true;

      document.addEventListener("click", (e) => {
        const drawer = document.getElementById("mobile-filter-drawer");
        if (drawer && drawer.contains(e.target)) {
          if (e.target.closest("[data-mobile-filter-close]") || e.target.closest("[data-mobile-filter-overlay]")) {
            closeMobileDrawer();
            return;
          }
          if (e.target.closest("[data-mobile-filter-apply]")) {
            applyMobileFilters();
            return;
          }
          if (e.target.closest("[data-mobile-filter-clear]")) {
            clearMobileFilters();
            return;
          }
          const categoryBtn = e.target.closest("[data-mobile-category]");
          if (categoryBtn) {
            showFilterDetail(categoryBtn.dataset.mobileCategory);
            return;
          }
          if (e.target.closest("[data-mobile-back]")) {
            showFilterMain();
            return;
          }
          const mobilePrice = e.target.closest("[data-price-filter]");
          if (mobilePrice) {
            handleMobilePriceToggle(mobilePrice);
            return;
          }
          return;
        }

        if (e.target.closest("[data-mobile-filter-open]")) {
          openMobileDrawer();
          return;
        }

        const filterTrigger = e.target.closest("[data-filter-trigger]");
        if (filterTrigger) {
          const dropdown = filterTrigger.closest("[data-filter-dropdown]");
          if (dropdown) {
            const panel = dropdown.querySelector("[data-filter-panel]");
            if (panel && panel.classList.contains("hidden")) {
              openDropdown(dropdown);
            } else {
              closeDropdown(dropdown);
            }
          }
          return;
        }

        const sortTrigger = e.target.closest("[data-sort-trigger]");
        if (sortTrigger) {
          closeAllDropdowns();
          const wrapper = sortTrigger.closest("[data-sort-wrapper]");
          const panel = wrapper && wrapper.querySelector("[data-sort-panel]");
          if (panel && panel.classList.contains("hidden")) {
            panel.classList.remove("hidden");
            sortTrigger.setAttribute("aria-expanded", "true");
          } else if (panel) {
            panel.classList.add("hidden");
            sortTrigger.setAttribute("aria-expanded", "false");
          }
          return;
        }

        const sortOption = e.target.closest("[data-sort-option]");
        if (sortOption) {
          const value = sortOption.dataset.sortValue;
          document.querySelectorAll("[data-sort-select]").forEach((s) => {
            s.value = value;
          });
          const wrapper = sortOption.closest("[data-sort-wrapper]");
          const label = wrapper && wrapper.querySelector("[data-sort-label]");
          if (label) label.textContent = sortOption.querySelector("span").textContent;
          closeSortPanel();
          handleSortChange();
          return;
        }

        const filterToggle = e.target.closest("[data-filter-toggle]");
        if (filterToggle) {
          handleDesktopToggle(filterToggle);
          return;
        }

        const desktopBar = document.querySelector("[data-desktop-filters]");
        const priceBtn = e.target.closest("[data-price-filter]");
        if (priceBtn && desktopBar && desktopBar.contains(priceBtn)) {
          handleDesktopPriceFilter(priceBtn);
          return;
        }

        if (e.target.closest("[data-brand-search]")) {
          return;
        }

        const filterRemove = e.target.closest("[data-filter-remove]");
        if (filterRemove) {
          handleFilterRemove(e, filterRemove);
          return;
        }

        const pricePillRemove = e.target.closest("[data-price-pill-remove]");
        if (pricePillRemove) {
          handlePricePillRemove(pricePillRemove);
          return;
        }

        const clearAll = e.target.closest("[data-filter-clear-all]");
        if (clearAll) {
          handleClearAll(e, clearAll);
          return;
        }

        if (!e.target.closest("[data-filter-dropdown]") && !e.target.closest("[data-sort-wrapper]")) {
          closeAllDropdowns();
          closeSortPanel();
        }
      });

      document.addEventListener("change", (e) => {
        const cb = e.target.closest("[data-filter-checkbox]");
        if (cb) {
          const desktopBar = document.querySelector("[data-desktop-filters]");
          if (desktopBar && desktopBar.contains(cb)) {
            handleDesktopFilterChange();
            return;
          }
          const drawer = document.getElementById("mobile-filter-drawer");
          if (drawer && drawer.contains(cb)) {
            const label = cb.closest("label");
            if (label) handleMobileCheckboxToggle(label);
            return;
          }
        }

        const sortSelect = e.target.closest("[data-sort-select]");
        if (sortSelect) {
          document.querySelectorAll("[data-sort-select]").forEach((s) => {
            s.value = sortSelect.value;
          });
          const label = sortSelect.closest("[data-sort-wrapper]")?.querySelector("[data-sort-label-mobile]");
          if (label) {
            const opt = sortSelect.options[sortSelect.selectedIndex];
            if (opt) label.textContent = opt.textContent;
          }
          handleSortChange();
        }
      });

      document.addEventListener("input", (e) => {
        const input = e.target.closest("[data-brand-search]");
        if (!input) return;
        const query = input.value.toLowerCase();
        const panel = input.closest("[data-filter-panel]");
        if (!panel) return;
        panel.querySelectorAll("[data-filter-item]").forEach((item) => {
          const text = item.querySelector(".flex-1").textContent.toLowerCase();
          item.style.display = text.includes(query) ? "" : "none";
        });
      });

      window.addEventListener("scroll", () => {
        const openDrop = [...document.querySelectorAll("[data-filter-dropdown]")].find(
          (d) => {
            const p = d.querySelector("[data-filter-panel]");
            return p && !p.classList.contains("hidden");
          }
        );

        if (openDrop) {
          if (openPanelScrollY === null) openPanelScrollY = window.scrollY;
          if (Math.abs(window.scrollY - openPanelScrollY) > 80) {
            closeAllDropdowns();
            closeSortPanel();
            openPanelScrollY = null;
          } else {
            positionDropdownPanel(openDrop);
          }
          return;
        }

        openPanelScrollY = null;
        closeSortPanel();
      }, { passive: true });
    }

    initInfiniteScroll();
    initFilterScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      bindEventListeners();
      syncPriceFilterStates();
      syncFilterChips();
      fetchPriceRangeCounts();
    });
  } else {
    bindEventListeners();
    syncPriceFilterStates();
    syncFilterChips();
    fetchPriceRangeCounts();
  }
})();
